import ReviewSubmission from './form/ReviewSubmission'
import FacilityAliasForm from './form/FacilityAliasForm'
import SearchForm from './form/searchForm/SearchForm'

export default (
    formType,
    configuredNavGroups,
    isSearchTabVisible,
    isReview
) => {
    let allNavGroups = configuredNavGroups

    const aliasTab = {
        groupName: 'Well Alias Information',
        requires: null,
        type: 'component',
        component: FacilityAliasForm,
        dataAccessor: 'facilityAlias',
    }

    const reviewTab = {
        groupName: 'Review',
        requires: null,
        type: 'component',
        component: ReviewSubmission,
        dataAccessor: 'facility',
    }

    const searchTab = {
        groupName: 'Station Search',
        requires: null,
        type: 'component',
        component: SearchForm,
        props: {
            formType
        },
        dataAccessor: 'facility',
        // dataAccessor: primaryAccessor,
    }

    allNavGroups = [...allNavGroups]

    if (isSearchTabVisible) {
        allNavGroups = [searchTab, ...allNavGroups]
    }

    if (isReview) {
        allNavGroups = [...allNavGroups, reviewTab]
    }

    return allNavGroups
}
